import { Type } from 'class-transformer';
import {
  IsNotEmpty,
  IsOptional,
  IsString,
  IsArray,
  ArrayMinSize,
  IsUUID,
  IsDateString,
  IsBoolean,
  IsObject,
  ValidateNested,
} from 'class-validator';

import { t } from '@vk-hr-tek/core/translations/t';
import type { UnitType } from '@vk-hr-tek/core/units';
import type { FileInputValue } from '@vk-hr-tek/ui/input';

export class CreateEventBatchDto {
  @IsUUID(undefined, {
    message: 'Вы указали неверную компанию',
    groups: ['default', 'child'],
  })
  @IsNotEmpty({
    message: 'Вы забыли выбрать компанию',
    groups: ['default', 'child'],
  })
  companyId: string;

  @IsUUID(undefined, {
    message: 'Вы указали неверный тип',
    groups: ['default', 'child'],
  })
  @IsNotEmpty({
    message: 'Вы забыли выбрать тип',
    groups: ['default', 'child'],
  })
  eventTypeId: string;

  @Type(() => String)
  @ArrayMinSize(1, {
    message: () => t('event.dto.createEventBatch.forgotToSetEmployees'),
    groups: ['need-employees'],
  })
  @IsArray({ groups: ['need-employees', 'child'] })
  @IsOptional({
    message: () => t('event.dto.createEventBatch.forgotToSetEmployees'),
    groups: ['default', 'child'],
  })
  employees: string[];

  @IsUUID(undefined, {
    message: 'Вы указали неверный тип',
    groups: ['default', 'child'],
  })
  @IsOptional({ groups: ['default', 'child'] })
  eventBatchId?: string;

  @IsString({
    message: 'Вы ввели неверное название',
    groups: ['default', 'child'],
  })
  @IsNotEmpty({
    message: 'Вы забыли ввести название',
    groups: ['default', 'child'],
  })
  eventBatchName: string;

  @Type(() => String)
  @IsNotEmpty({
    message: 'Вы забыли загрузить документ',
    groups: ['document-required'],
  })
  document: FileInputValue;

  @IsString({ groups: ['default', 'child'] })
  @IsOptional({ groups: ['default', 'child'] })
  unitType?: UnitType;

  @Type(() => String)
  @IsArray()
  @IsNotEmpty({ groups: ['default', 'child'] })
  unitIds: string[];

  @IsDateString(undefined, { groups: ['document-required'] })
  @IsOptional({ groups: ['document-required'] })
  documentDate?: string;

  @IsString({ groups: ['default', 'child'] })
  @IsOptional({ groups: ['default', 'child'] })
  documentNumber?: string;

  @IsArray({ groups: ['default', 'child'] })
  @IsOptional({ groups: ['default', 'child'] })
  assignedRoles?: string[];

  @ValidateNested({ each: true })
  @IsObject()
  @IsOptional()
  assignedValues?: Record<string, string | string[]>;

  @IsUUID(undefined, {
    groups: ['default', 'child'],
  })
  @IsOptional({ groups: ['default', 'child'] })
  parentEventId?: string;

  @Type(() => String)
  @ValidateNested({ each: true })
  @IsObject({ each: true })
  @IsOptional()
  attributes?: Record<string, string | File | (string | File)[]>;

  @IsBoolean()
  @IsOptional()
  allEmployees?: boolean;
}
